import React from "react";
import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import { AuthContext } from "../../../shared/context/auth-context";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { toast } from "react-hot-toast";
import "./ExecutarPlanoTratamento.scss";

import { useLoading } from "../../../shared/context/LoadingContext";

//mui icons
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DoneIcon from "@mui/icons-material/Done";
import SettingsIcon from "@mui/icons-material/Settings";

import SessaoInfoTooltip from "./sessaoInfoTooltip/SessaoInfoTooltip";
import BadgeUnidade from "../../../shared/components/badgeUnidade/BadgeUnidade";

import { ClinicaContext } from "../../../shared/context/clinica-context";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function ExecutarPlanoTratamento() {
  const { startLoading, stopLoading } = useLoading();

  const [evolucao, setEvolucao] = useState();
  const [planoSelecionadoId, setPlanoSelecionadoId] = useState();
  const [procedimento, setProcedimento] = useState();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [step, setStep] = useState("1");
  const [marcacao, setMarcacao] = useState();
  const [notificacaoEmStep2, setNotificacaoEmStep2] = useState("");
  const clinica = useContext(ClinicaContext);
  const tipoAgendamento =
    clinica?.clinica?.configuracoes?.configuracoes?.tipoAgendamento?.tipo;
  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);

  const temporary = useParams().planoTratamentoId;
  const planoTratamentoId = temporary.split("-")[0];
  const marcacaoId = temporary.split("-")[1];
  const clienteId = temporary.split("-")[2];

  const [planosTratamento, setPlanosTratamento] = useState([]);
  const [planosTratamentoDesativados, setPlanosTratamentoDesativados] =
    useState([]);

  //Dialog confirmação cancelamento execucao de procedimento
  const [open, setOpen] = useState(false);
  const [procedimentoParaCancelar, setProcedimentoParaCancelar] =
    useState(null);
  const [planoIdParaCancelar, setPlanoIdParaCancelar] = useState(null);

  // Adicionar no início do componente ExecutarPlanoTratamento
  const [procedimentosSelecionados, setProcedimentosSelecionados] = useState(
    [],
  );
  // Formato: [{ procedimentoId: "123", planoId: "456", procedimento: {...} }]
  const [modalBulkOpen, setModalBulkOpen] = useState(false);
  const [evolucaoBulk, setEvolucaoBulk] = useState("");

  // Função para toggle de seleção de procedimento
  // Função para toggle de seleção de procedimento
  const handleToggleProcedimento = (proc, planoId) => {
    // Verificar se o plano está interrompido
    const plano = planosTratamento.find((p) => p._id === planoId);
    if (plano?.status === "INTERROMPIDO") {
      toast.error(
        "Não é possível selecionar procedimentos de planos interrompidos",
      );
      return;
    }

    const exists = procedimentosSelecionados.find(
      (p) => p.procedimentoId === proc.id && p.planoId === planoId,
    );

    if (exists) {
      setProcedimentosSelecionados((prev) =>
        prev.filter(
          (p) => !(p.procedimentoId === proc.id && p.planoId === planoId),
        ),
      );
    } else {
      setProcedimentosSelecionados((prev) => [
        ...prev,
        { procedimentoId: proc.id, planoId: planoId, procedimento: proc },
      ]);
    }
  };

  // Função para selecionar todos de um plano
  const handleSelecionarTodosPlano = (planoId) => {
    const plano = planosTratamento.find((p) => p._id === planoId);
    const procedimentosNaoCompletos = plano.procedimentos.filter(
      (p) => !p.procedimento_completo,
    );

    // Verificar se todos já estão selecionados
    const todosSelecionados = procedimentosNaoCompletos.every((proc) =>
      procedimentosSelecionados.some(
        (ps) => ps.procedimentoId === proc.id && ps.planoId === planoId,
      ),
    );

    if (todosSelecionados) {
      // Se todos estão selecionados, remove todos deste plano
      setProcedimentosSelecionados((prev) =>
        prev.filter((ps) => ps.planoId !== planoId),
      );
    } else {
      // Adiciona apenas os que ainda não estão selecionados
      const novosProcs = procedimentosNaoCompletos
        .filter(
          (proc) =>
            !procedimentosSelecionados.some(
              (ps) => ps.procedimentoId === proc.id && ps.planoId === planoId,
            ),
        )
        .map((proc) => ({
          procedimentoId: proc.id,
          planoId: planoId,
          procedimento: proc,
        }));

      setProcedimentosSelecionados((prev) => [...prev, ...novosProcs]);
    }
  };
  // Função para limpar seleção
  const handleLimparSelecao = () => {
    setProcedimentosSelecionados([]);
  };

  // Função para abrir modal de execução em massa
  const handleAbrirModalBulk = (acao) => {
    setModalBulkOpen(true);
  };

  // Função para executar em massa (guardar)
  const handleGuardarBulk = async () => {
    startLoading();
    setIsSubmiting(true);

    try {
      // Preparar dados para enviar
      const sessoes = procedimentosSelecionados.map((item) => ({
        planoId: item.planoId,
        procedimentoId: item.procedimentoId,
        procedimentoNome: item.procedimento.tratamento.designacao,
        evolucao: evolucaoBulk || "Procedimento executado.",
        data_inicio_execucao: marcacao.data_inicio_execucao,
        data_fim_execucao: marcacao.data_fim_execucao,
        medico: auth.userId,
      }));

      // Uma única chamada ao backend
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/adicionar-sessoes/bulk`,
        "PATCH",
        JSON.stringify({
          sessoes,
          marcacaoId,
          tipoAgendamento,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
      );

      // Recarregar dados
      await fetchData();

      toast.success(`${procedimentosSelecionados.length} sessões adicionadas!`);
      handleLimparSelecao();
      setModalBulkOpen(false);
      setEvolucaoBulk("");
    } catch (err) {
      console.error("err", err);
      toast.error("Erro ao guardar procedimentos");
    } finally {
      setIsSubmiting(false);
      stopLoading();
    }
  };

  // Função para finalizar em massa
  const handleFinalizarBulk = async () => {
    startLoading();
    setIsSubmiting(true);

    try {
      // Preparar dados para enviar
      const procedimentos = procedimentosSelecionados.map((item) => ({
        planoId: item.planoId,
        procedimentoId: item.procedimentoId,
        procedimentoNome: item.procedimento.tratamento.designacao,
        evolucao: evolucaoBulk || "Procedimento Executado",
        data_inicio_execucao: marcacao.data_inicio_execucao,
        data_fim_execucao: marcacao.data_fim_execucao,
        medico: auth.userId,
      }));

      // Uma única chamada ao backend
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/finalizar-procedimentos/bulk`,
        "PATCH",
        JSON.stringify({
          procedimentos,
          marcacaoId,
          tipoAgendamento,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
      );

      // Recarregar dados
      await fetchData();

      toast.success(
        `${procedimentosSelecionados.length} procedimentos finalizados!`,
      );
      handleLimparSelecao();
      setModalBulkOpen(false);
      setEvolucaoBulk("");
    } catch (err) {
      console.error("err", err);
      toast.error("Erro ao finalizar procedimentos");
    } finally {
      setIsSubmiting(false);
      stopLoading();
    }
  };

  const handleClickOpen = (proc, planoId) => {
    setProcedimentoParaCancelar(proc);
    setPlanoIdParaCancelar(planoId);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirmarCancelamento = () => {
    handleCancelarProcedimento(
      procedimentoParaCancelar.id,
      planoIdParaCancelar,
    );
    setOpen(false);
    setProcedimentoParaCancelar(null);
    setPlanoIdParaCancelar(null);
  };

  const fetchData = async () => {
    startLoading();
    try {
      const [planosTratamentoResponse, marcacaoResponse] = await Promise.all([
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/ativosInativos/cliente/${clienteId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${
            tipoAgendamento === "Tratamento" ? "agendatratamento" : "agenda"
          }/marcacao/${marcacaoId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
      ]);

      const tempPlanosTratamentoAtivados =
        planosTratamentoResponse.planosTratamento.filter(
          (p) => p.ativo === true,
        );
      const tempPlanosTratamentoDesativados =
        planosTratamentoResponse.planosTratamento.filter(
          (p) => p.ativo === false,
        );

      planosTratamentoResponse.planosTratamento.filter((p) => p.ativo === true);
      // Process plano de tratamento
      const planosAtivosFinais = processPlanosTratamento(
        tempPlanosTratamentoAtivados,
      );
      setPlanosTratamento(planosAtivosFinais);

      const planosInativosFinais = processPlanosTratamento(
        tempPlanosTratamentoDesativados,
      );
      setPlanosTratamentoDesativados(planosInativosFinais);

      // Set marcação
      setMarcacao(marcacaoResponse.marcacao);

      /* Devolve os planos já processados, além de os guardar no estado.
         Quem chama logo a seguir precisa deles na mesma passagem — o estado só
         está disponível na renderização seguinte. Devolver aqui evita que cada
         chamador refaça o pedido ou, pior, reconstrua os dados à mão a partir
         do que tem no ecrã. */
      return planosAtivosFinais;
    } catch (err) {
      console.error("err", err);
      return null;
    } finally {
      stopLoading();
    }
  };

  //fetch planoTratamento, medicos
  useEffect(() => {
    fetchData();
  }, [sendRequest, planoTratamentoId, marcacaoId, auth.token]);

  // Helper functions
  const processPlanosTratamento = (planosTratamento) => {
    return planosTratamento.map((plano) => {
      const sortedProcedimentos = [...plano.procedimentos].sort((a, b) => {
        if (a.procedimento_completo && !b.procedimento_completo) return 1;
        if (!a.procedimento_completo && b.procedimento_completo) return -1;
        return 0;
      });

      return {
        ...plano,
        procedimentos: sortedProcedimentos,
      };
    });
  };
  //////////////////////////////////////////////

  const submitHandler = async () => {
    startLoading();
    try {
      const planoFiltrado = planosTratamento.find(
        (p) => p._id === planoSelecionadoId,
      );

      const procedimentosTrabalhados = [];
      let procedimentoEfetuado;

      planoFiltrado.procedimentos.forEach((proc) => {
        if (proc.id === procedimento.id) {
          procedimentoEfetuado = proc.tratamento.designacao;
          procedimentosTrabalhados.push({
            ...proc,
            tratamento: proc.tratamento._id,
            procedimento_completo: true,
            data_inicio_execucao: proc.sessoes[0]
              ? proc.sessoes[0].data_inicio_execucao
              : marcacao.data_inicio_execucao,
            data_fim_execucao: marcacao.data_fim_execucao,
            sessoes: [
              ...proc.sessoes.map((s) => ({ ...s, medico: s.medico._id })),
              {
                data_inicio_execucao: marcacao.data_inicio_execucao,
                data_fim_execucao: marcacao.data_fim_execucao,
                evolucao: evolucao ? evolucao : "Procedimento Executado",
                medico: auth.userId,
              },
            ],
          });
        } else {
          procedimentosTrabalhados.push({
            ...proc,
            tratamento: proc.tratamento._id,
          });
        }
      });

      if (notificacaoEmStep2) {
        const formData = new FormData();

        if (tipoAgendamento === "Tratamento") {
          formData.append("tratamento", procedimento.tratamento._id);
        } else {
          formData.append(
            "categoriaTratamento",
            procedimento.tratamento.categoria,
          );
        }

        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${
            tipoAgendamento === "Tratamento" ? "agendatratamento" : "agenda"
          }/alterartratamentonamarcacao/${marcacaoId}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      }

      //Marca a sessão como atendida
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${
          tipoAgendamento === "Tratamento" ? "agendatratamento" : "agenda"
        }/marcaratendido/${marcacaoId}`,
        "PATCH",
        null,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const formData = new FormData();
      formData.append(
        "procedimentos",
        JSON.stringify(procedimentosTrabalhados),
      );
      formData.append("utilizador", auth.userId);
      formData.append("operacao", "EXECUCAO");
      formData.append("procedimentoId", procedimento.id);
      formData.append("procedimentoNome", procedimentoEfetuado);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/${planoSelecionadoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      await fetchData();

      toast.success("Procedimento finalizado!");
      setEvolucao("");
      setStep("1");
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmiting(false);
      stopLoading();
    }
  };

  const handleGuardar = async () => {
    setIsSubmiting(true);
    startLoading();
    try {
      if (notificacaoEmStep2) {
        const formData = new FormData();

        if (tipoAgendamento === "Tratamento") {
          formData.append("tratamento", procedimento.tratamento._id);
        } else {
          formData.append(
            "categoriaTratamento",
            procedimento.tratamento.categoria,
          );
        }

        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/${
            tipoAgendamento === "Tratamento" ? "agendatratamento" : "agenda"
          }/alterartratamentonamarcacao/${marcacaoId}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      }

      //Marca a sessão como atendida
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${
          tipoAgendamento === "Tratamento" ? "agendatratamento" : "agenda"
        }/marcaratendido/${marcacaoId}`,
        "PATCH",
        null,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      //Ao clicar em guardar, é adicionada uma sessão
      const formData3 = new FormData();
      formData3.append("planoTratamentoId", planoSelecionadoId);
      formData3.append("data_inicio_execucao", marcacao.data_inicio_execucao);
      formData3.append("data_fim_execucao", marcacao.data_fim_execucao);
      formData3.append(
        "evolucao",
        evolucao ? evolucao : "Procedimento executado.",
      );
      formData3.append("medico", auth.userId);
      formData3.append("nomeProcedimento", procedimento.tratamento.designacao);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/adicionarsessao/${procedimento.id}`,
        "PATCH",
        formData3,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      await fetchData();

      toast.success("Sessão do procedimento efetuada!");
      setEvolucao("");
      setStep("1");
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmiting(false);
      stopLoading();
    }
  };

  const preSubmitHandler = () => {
    setIsSubmiting(true);
    submitHandler();
  };

  /* Eliminar uma sessão passada, igual ao modal de executar da ficha do
     paciente — os dois ecrãs mostram a mesma lista e não faziam o mesmo.
     Só o médico que a executou a pode apagar. */
  const [sessaoAApagar, setSessaoAApagar] = useState(null);

  const handleApagarSessao = async (sessaoId) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("sessaoId", sessaoId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/eliminarsessao/${planoSelecionadoId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      /* Recarrega-se tudo e volta-se a escolher o procedimento a partir dos
         dados frescos. Podia usar-se o plano que o endpoint devolve, mas esse
         vem noutra forma — sem o virtual `id` de que esta página depende em
         dezasseis sítios — e guardá-lo no estado partia o resto do ecrã em
         silêncio. Assim o procedimento volta exatamente como a página o espera. */
      const planosFrescos = await fetchData();

      const planoFresco = planosFrescos?.find(
        (p) => String(p._id) === String(planoSelecionadoId),
      );
      const procFresco = planoFresco?.procedimentos?.find(
        (p) => String(p._id) === String(procedimento._id),
      );

      toast.success("Sessão eliminada com sucesso");

      /* Sem sessões não há execução a continuar — volta-se à lista de
         procedimentos em vez de ficar um ecrã vazio. */
      if (!procFresco?.sessoes?.length) {
        setStep("1");
        setProcedimento(procFresco || undefined);
      } else {
        setProcedimento(procFresco);
      }
    } catch (err) {
      console.error("err", err);
      toast.error(err.message || "Erro ao eliminar a sessão");
    } finally {
      setSessaoAApagar(null);
      stopLoading();
    }
  };

  const handleChooseProcedimento = (idPro, idPlano) => {
    setPlanoSelecionadoId(idPlano);
    setStep("2");

    const planoFiltrado = planosTratamento.find((p) => p._id === idPlano);
    const procedimentoFiltrado = planoFiltrado.procedimentos.filter(
      (p) => p.id === idPro,
    )[0];
    setProcedimento(procedimentoFiltrado);

    if (tipoAgendamento === "Tratamento") {
      if (procedimentoFiltrado.tratamento._id !== marcacao.tratamento._id)
        setNotificacaoEmStep2(
          "ATENÇÃO. O TRATAMENTO QUE ESCOLHEU NÃO CORRESPONDE AO TRATAMENTO DA AGENDA!",
        );
    } else {
      if (
        procedimentoFiltrado.tratamento.categoria !==
        marcacao.categoriaTratamento._id
      )
        setNotificacaoEmStep2(
          "ATENÇÃO. O TRATAMENTO QUE ESCOLHEU NÃO CORRESPONDE À CATEGORIA DO TRATAMENTO DA AGENDA!",
        );
    }
  };

  const handleVoltar = () => {
    setProcedimento(null);
    setEvolucao("");
    setNotificacaoEmStep2("");
    setStep("1");
  };

  const handleCancelarProcedimento = async (idProc, planoId) => {
    startLoading();
    try {
      const planoFiltrado = planosTratamento.find((p) => p._id === planoId);

      const procedimentosTrabalhados = [];
      let procedimentoEfetuado;

      planoFiltrado.procedimentos.forEach((proc) => {
        if (proc.id === idProc) {
          procedimentoEfetuado = proc.tratamento.designacao;
          procedimentosTrabalhados.push({
            ...proc,
            sessoes: proc.sessoes.slice(0, -1),
            tratamento: proc.tratamento._id,
            procedimento_completo: false,
            data_fim_execucao: null,
            data_inicio_execucao: null,
          });
        } else {
          procedimentosTrabalhados.push({
            ...proc,
            tratamento: proc.tratamento._id,
          });
        }
      });

      const formData = new FormData();
      formData.append(
        "procedimentos",
        JSON.stringify(procedimentosTrabalhados),
      );
      formData.append("utilizador", auth.userId);
      formData.append("operacao", "CANCELAMENTO");
      formData.append("procedimentoId", idProc);
      formData.append("procedimentoNome", procedimentoEfetuado);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/${planoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      await fetchData();

      toast.success(`Execução do procedimento cancelado.`);
    } catch (err) {
      console.error("err", err);
    } finally {
      setIsSubmiting(false);
      stopLoading();
    }
  };

  const hasSessions = (planoT) => {
    // Check if any procedimento has sessions
    const hasSessions = planoT.procedimentos.some(
      (procedimento) => procedimento.sessoes && procedimento.sessoes.length > 0,
    );

    // Return true only if there are sessions
    return hasSessions;
  };

  // Função para determinar o status do plano
  const getPlanoStatus = (plano) => {
    // Prioridade 1: Não tem sessões
    if (hasSessions(plano) === false) {
      return {
        label: "Por iniciar",
        color: "#fdcb7f",
        backgroundColor: "#fff7eb",
      };
    }

    // Prioridade 2: Está completo
    if (plano.plano_completo) {
      return {
        label: "Finalizado",
        color: "#12d453",
        backgroundColor: "#e5faec",
      };
    }

    // Prioridade 3: Está interrompido
    if (plano.status === "INTERROMPIDO") {
      return {
        label: "Interrompido",
        color: "#eb3c5f",
        backgroundColor: "rgba(241, 167, 182, 0.47)",
      };
    }

    return {
      label: `Em progresso`,
      color: "#1976d2",
      backgroundColor: "#e3f2fd",
    };
  };

  const todosProcedimentosSelecionados = (planoId) => {
    const plano = planosTratamento.find((p) => p._id === planoId);
    if (!plano) return false;

    const procedimentosNaoCompletos = plano.procedimentos.filter(
      (p) => !p.procedimento_completo,
    );

    if (procedimentosNaoCompletos.length === 0) return false;

    return procedimentosNaoCompletos.every((proc) =>
      procedimentosSelecionados.some(
        (ps) => ps.procedimentoId === proc.id && ps.planoId === planoId,
      ),
    );
  };

  return (
    <>
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          {planosTratamento && (
            <Navbar
              title="Executar procedimento"
              icon={NoteAltOutlinedIcon}
              paths={[
                {
                  nome: `${planosTratamento[0]?.cliente?.nome}`,
                  link: `../../../clientes/${clienteId}-planotratamento`,
                },
                { nome: "Executar" },
              ]}
            />
          )}
          {step === "1" && procedimentosSelecionados.length > 0 && (
            <div
              style={{
                margin: "30px",
                padding: "15px",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#666", fontWeight: "500" }}>
                {procedimentosSelecionados.length} procedimento(s)
                selecionado(s)
              </span>
              <button className="blue-button" onClick={handleAbrirModalBulk}>
                Executar Todos ({procedimentosSelecionados.length})
              </button>
              <button className="cancel-btn" onClick={handleLimparSelecao}>
                Limpar Seleção
              </button>
            </div>
          )}

          {planosTratamento.length === 0 && (
            <div className="caixa executarProcedimento__notificacaoContainer">
              Nenhum plano de tratamento ativo encontrado. O plano que procura,
              muito possivelmente foi desativado!
            </div>
          )}

          {step === "1" && (
            <>
              {planosTratamento.map((plano) => (
                <Accordion
                  key={plano._id}
                  style={{ margin: "30px", borderRadius: "10px" }}
                  defaultExpanded={
                    !plano.plano_completo && plano.status !== "INTERROMPIDO"
                  }
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "2rem",
                          "&:hover": {
                            transform: "scale(1.2)",
                            color: "primary.main",
                            filter: "brightness(1.2)",
                            transition: "all 0.2s ease-in-out",
                          },
                        }}
                      />
                    }
                    sx={{
                      height: "55px",
                      backgroundColor:
                        plano.status === "INTERROMPIDO" ? "#fff8f8" : "#fdfdfd",
                      borderLeft:
                        plano.status === "INTERROMPIDO"
                          ? "4px solid #eb3c5f"
                          : "4px solid #4caf50",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <span>
                          Plano de Tratamento {plano.numero}
                          {(plano.data_inicio ||
                            plano.data_fim ||
                            plano.status === "INTERROMPIDO") && (
                            <>
                              {" - "}
                              <span className="debitos__accordion__title">
                                {plano.data_inicio
                                  ? moment(
                                      plano.data_inicio,
                                      "YYYYY-MM-DD",
                                    ).format("DD/MM/YYYY")
                                  : "?"}{" "}
                                a
                                {(() => {
                                  // Se tem data_fim, usa ela
                                  if (plano.data_fim) {
                                    return moment(
                                      plano.data_fim,
                                      "YYYY-MM-DD",
                                    ).format("DD/MM/YYYY");
                                  }

                                  // Se é interrompido, calcular última data de execução
                                  if (plano.status === "INTERROMPIDO") {
                                    let ultimaData = null;
                                    plano.procedimentos.forEach((proc) => {
                                      if (
                                        proc.sessoes &&
                                        proc.sessoes.length > 0
                                      ) {
                                        const ultimaSessao =
                                          proc.sessoes[proc.sessoes.length - 1];
                                        if (ultimaSessao.data_fim_execucao) {
                                          const dataExecucao = new Date(
                                            ultimaSessao.data_fim_execucao,
                                          );
                                          if (
                                            !ultimaData ||
                                            dataExecucao > ultimaData
                                          ) {
                                            ultimaData = dataExecucao;
                                          }
                                        }
                                      }
                                    });
                                    return ultimaData
                                      ? moment(ultimaData).format("DD/MM/YYYY")
                                      : "?";
                                  }

                                  return "?";
                                })()}
                              </span>
                            </>
                          )}
                        </span>

                        <Chip
                          label={getPlanoStatus(plano).label}
                          size="small"
                          sx={{
                            color: getPlanoStatus(plano).color,
                            backgroundColor:
                              getPlanoStatus(plano).backgroundColor,
                          }}
                        />
                        {plano.status !== "INTERROMPIDO" &&
                          !plano.plano_completo && (
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelecionarTodosPlano(plano._id);
                              }}
                            >
                              {todosProcedimentosSelecionados(plano._id)
                                ? "Desselecionar Todos"
                                : "Selecionar Todos"}
                            </Button>
                          )}
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    {plano && plano.status === "INTERROMPIDO" && (
                      <div className="caixa executarProcedimento__notificacaoContainer">
                        <span className="executarProcedimento__notificacaoContainer__titulo">
                          Atenção! Esse plano de tratamento foi interrompido.
                        </span>
                        <div>
                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            Motivo :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {plano.motivoEncerramento?.tipo}
                          </span>
                        </div>
                        <div>
                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            Descrição :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {plano.motivoEncerramento?.descricao}
                          </span>
                        </div>
                        <div>
                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            Interrompido Por :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {plano.motivoEncerramento.responsavel?.name + "   "}
                          </span>

                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            {" "}
                            Data :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {moment(plano.motivoEncerramento.data).format(
                              "DD-MM-YYYY",
                            )}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="executarProcedimento__step1 caixa">
                      <span className="executarProcedimento__step1__tabela-heading  executarProcedimento__step1__tabela-heading--1st">
                        Tratamento
                      </span>
                      <span className="executarProcedimento__step1__tabela-heading">
                        Dentes
                      </span>
                      <span className="executarProcedimento__step1__tabela-heading">
                        Faces
                      </span>
                      <span className="executarProcedimento__step1__tabela-heading">
                        Sessões
                      </span>
                      <span className="executarProcedimento__step1__tabela-heading">
                        Estado
                      </span>
                      <span className="executarProcedimento__step1__tabela-heading executarProcedimento__step1__tabela-heading--last">
                        Ação
                      </span>

                      {plano &&
                        plano.procedimentos.map(
                          (p, index) =>
                            !p.procedimento_completo && (
                              <React.Fragment key={index}>
                                <span className="executarProcedimento__step1__lineItem executarProcedimento__step1__lineItem--1st">
                                  <input
                                    type="checkbox"
                                    checked={procedimentosSelecionados.some(
                                      (ps) =>
                                        ps.procedimentoId === p.id &&
                                        ps.planoId === plano._id,
                                    )}
                                    onChange={() =>
                                      handleToggleProcedimento(p, plano._id)
                                    }
                                    style={{
                                      marginRight: "10px",
                                      cursor: "pointer",
                                    }}
                                  />
                                  {p.tratamento.designacao}
                                </span>
                                <span className="executarProcedimento__step1__lineItem">
                                  {p.dente}
                                </span>
                                <span className="executarProcedimento__step1__lineItem">
                                  {p.faces.join(" ,")}
                                </span>

                                {p.sessoes.length === 0 ? (
                                  <span className="executarProcedimento__step1__lineItem">
                                    {p.sessoes.length}
                                  </span>
                                ) : (
                                  <SessaoInfoTooltip procedimento={p} />
                                )}
                                <div className="executarProcedimento__step1__procedimento__container executarProcedimento__step1__lineItem">
                                  <span
                                    className={`
                        executarProcedimento__step1__procedimento
                        ${
                          p.sessoes.length > 0
                            ? "executarProcedimento__step1__procedimento-emProgresso"
                            : "executarProcedimento__step1__procedimento-novo"
                        }
                      `}
                                  >
                                    {p.sessoes.length > 0 ? (
                                      <>
                                        <SettingsIcon className="executarProcedimento__step1__procedimento__icon" />{" "}
                                        Em Progresso
                                      </>
                                    ) : (
                                      <>
                                        <StarBorderIcon className="executarProcedimento__step1__procedimento__icon" />{" "}
                                        Novo
                                      </>
                                    )}
                                  </span>
                                </div>

                                <div className="executarProcedimento__step1__lineItem executarProcedimento__step1__btnContainer">
                                  {plano.status === "INTERROMPIDO" ? (
                                    <span
                                      className="
                        executarProcedimento__step1__procedimento procedimentoInterrompido
                        "
                                    >
                                      Interrompido
                                    </span>
                                  ) : (
                                    <span
                                      className="executarProcedimento__step1__btn-executar executarButton"
                                      onClick={handleChooseProcedimento.bind(
                                        null,
                                        p.id,
                                        plano._id,
                                      )}
                                    >
                                      Executar
                                    </span>
                                  )}
                                </div>
                              </React.Fragment>
                            ),
                        )}
                      <div
                        className="linhaCinzenta"
                        style={{ marginTop: "50px" }}
                      >
                        Finalizados
                      </div>
                      {plano &&
                        plano.procedimentos.map(
                          (p, index) =>
                            p.procedimento_completo && (
                              <React.Fragment key={index}>
                                <span className="executarProcedimento__step1__lineItem executarProcedimento__step1__lineItem--1st">
                                  {p.tratamento.designacao}
                                </span>
                                <span className="executarProcedimento__step1__lineItem">
                                  {p.dente}
                                </span>
                                <span className="executarProcedimento__step1__lineItem">
                                  {p.faces.join(" ,")}
                                </span>

                                <SessaoInfoTooltip procedimento={p} />
                                <div className="executarProcedimento__step1__procedimento__container executarProcedimento__step1__lineItem">
                                  <span
                                    className="
                        executarProcedimento__step1__procedimento executarProcedimento__step1__procedimento-completo"
                                  >
                                    <DoneIcon className="executarProcedimento__step1__procedimento__icon" />{" "}
                                    Completo
                                  </span>
                                </div>

                                <div className="executarProcedimento__step1__lineItem executarProcedimento__step1__btnContainer">
                                  {plano.status === "INTERROMPIDO" ? (
                                    <span
                                      className="
                        executarProcedimento__step1__procedimento procedimentoInterrompido
                        "
                                    >
                                      Interrompido
                                    </span>
                                  ) : (
                                    p.sessoes[p.sessoes.length - 1].medico
                                      .id === auth.userId && (
                                      <span
                                        className="executarProcedimento__step1__btn-executar cancelarButton"
                                        onClick={() =>
                                          handleClickOpen(p, plano._id)
                                        }
                                      >
                                        Cancelar
                                      </span>
                                    )
                                  )}
                                </div>
                              </React.Fragment>
                            ),
                        )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}

              {planosTratamentoDesativados.map((plano) => (
                <Accordion
                  key={plano._id}
                  style={{ margin: "30px", borderRadius: "10px" }}
                  defaultExpanded={false}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "2rem",
                          "&:hover": {
                            transform: "scale(1.2)",
                            color: "primary.main",
                            filter: "brightness(1.2)",
                            transition: "all 0.2s ease-in-out",
                          },
                        }}
                      />
                    }
                    sx={{
                      height: "55px",
                      backgroundColor: "#fff8f8",
                      borderLeft: "4px solid #eb3c5f",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <span>
                          Plano de Tratamento {plano.numero}
                          {(plano.data_inicio || plano.data_fim) && (
                            <>
                              {" - "}
                              <span className="debitos__accordion__title">
                                {plano.data_inicio
                                  ? moment(
                                      plano.data_inicio,
                                      "YYYYY-MM-DD",
                                    ).format("DD/MM/YYYY")
                                  : "?"}{" "}
                                a
                                {plano.data_fim
                                  ? moment(plano.data_fim, "YYYY-MM-DD").format(
                                      "DD/MM/YYYY",
                                    )
                                  : " ?"}
                              </span>
                            </>
                          )}
                        </span>

                        <Chip
                          label="DESATIVADO"
                          size="small"
                          sx={{
                            color: "#eb3c5f",
                            backgroundColor: "rgba(241, 167, 182, 0.47)",
                          }}
                        />
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    {plano && (
                      <div className="caixa executarProcedimento__notificacaoContainer">
                        <span className="executarProcedimento__notificacaoContainer__titulo">
                          Atenção! Esse plano de tratamento foi desativado.
                        </span>
                        <div>
                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            Desativado Por :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {plano.desativadoPor?.user?.name + "   "}
                          </span>

                          <span className="executarProcedimento__notificacaoContainer__subTitulo">
                            {" "}
                            Data :
                          </span>
                          <span className="executarProcedimento__notificacaoContainer__descricao">
                            {" "}
                            {plano.desativadoPor?.data
                              ? moment(plano.desativadoPor.data).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="executarProcedimento__step1__desativado caixa">
                      <span className="executarProcedimento__step1__desativado__tabela-heading  executarProcedimento__step1__desativado__tabela-heading--1st">
                        Tratamento
                      </span>
                      <span className="executarProcedimento__step1__desativado__tabela-heading">
                        Dentes
                      </span>
                      <span className="executarProcedimento__step1__desativado__tabela-heading">
                        Faces
                      </span>

                      {plano &&
                        plano.procedimentos.map((p, index) => (
                          <React.Fragment key={index}>
                            <span className="executarProcedimento__step1__desativado__lineItem executarProcedimento__step1__desativado__lineItem--1st">
                              {p.tratamento.designacao}
                            </span>
                            <span className="executarProcedimento__step1__desativado__lineItem">
                              {p.dente}
                            </span>
                            <span className="executarProcedimento__step1__desativado__lineItem">
                              {p.faces.join(" ,")}
                            </span>
                          </React.Fragment>
                        ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}

          {step === "2" && (
            <div className="executarProcedimento__step2">
              {procedimento && (
                <div className="bottom-orcamento caixa">
                  {notificacaoEmStep2 && (
                    <div className="notificacaoEmStep2">
                      {notificacaoEmStep2}
                    </div>
                  )}
                  <div className="executarProcedimento__container">
                    <span className="executarProcedimento__container__item--header">
                      Tratamento
                    </span>
                    <span className="executarProcedimento__container__item--header">
                      Dentes/Região
                    </span>

                    <span className="executarProcedimento__container__item--header">
                      Faces
                    </span>

                    <span className="executarProcedimento__container__item">
                      {procedimento.tratamento.designacao}
                    </span>
                    <span className="executarProcedimento__container__item">
                      {procedimento.dente}
                    </span>

                    <span className="executarProcedimento__container__item">
                      {procedimento.faces.join(", ")}
                    </span>

                    <textarea
                      className="executarProcedimento__container__textarea"
                      cols="30"
                      rows="3"
                      value={evolucao}
                      placeholder="Escreva aqui a evolução do procedimento."
                      onChange={(e) => {
                        e.target.value
                          ? setEvolucao(e.target.value)
                          : setEvolucao("");
                      }}
                    />

                    <div className="listaEvolucoesContainer">
                      {procedimento.sessoes.map((sessao, index) => (
                        <div className="evolucoesPassadasContainer" key={index}>
                          <span className="modalEvolucao__container__item--left__evolucao">
                            {sessao.evolucao}
                          </span>
                          <span className="modalEvolucao__container__item--left__otherinfo">
                            {moment(sessao.data_inicio_execucao).format(
                              "DD-MM-YYYY",
                            )}
                            ,{" "}
                            {moment(sessao.data_inicio_execucao).format(
                              "HH:mm",
                            )}{" "}
                            às{" "}
                            {moment(sessao.data_fim_execucao).format("HH:mm")}
                            {" - "}
                            {sessao.medico.genero === "masculino"
                              ? "Dr. "
                              : "Dra. "}
                            {sessao.medico.name}
                            {/* Onde a sessão foi executada — igual ao modal da
                                ficha do paciente, que é o outro caminho para
                                aqui. */}
                            <BadgeUnidade
                              estabelecimento={sessao.estabelecimento}
                              prefixo="Executada em"
                            />
                          </span>

                          {/* Eliminar, como no modal da ficha do paciente. Só a
                              quem executou a sessão. */}
                          {sessao.medico?._id === auth.userId &&
                            (sessaoAApagar === sessao._id ? (
                              <span className="evolucoesPassadasContainer__btns">
                                <Tooltip title="Confirmar eliminação">
                                  <IconButton
                                    onClick={() =>
                                      handleApagarSessao(sessao._id)
                                    }
                                  >
                                    <CheckIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Cancelar">
                                  <IconButton
                                    onClick={() => setSessaoAApagar(null)}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </span>
                            ) : (
                              <span className="evolucoesPassadasContainer__btns">
                                <Tooltip title="Eliminar sessão">
                                  <IconButton
                                    onClick={() => setSessaoAApagar(sessao._id)}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </span>
                            ))}
                        </div>
                      ))}
                    </div>
                  </div>

                  {step === "2" && (
                    <div className="botoes">
                      <button className="cancel-btn" onClick={handleVoltar}>
                        Voltar
                      </button>

                      <button
                        className="blue-button"
                        onClick={handleGuardar}
                        disabled={isSubmiting}
                      >
                        {isSubmiting ? "Guardando" : "Guardar"}
                      </button>

                      <button
                        disabled={isSubmiting}
                        className="blue-button"
                        onClick={preSubmitHandler}
                      >
                        {isSubmiting ? "Finalizando" : "Finalizar"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{
            style: {
              opacity: ".6",
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirmar cancelamento"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Tem certeza que deseja cancelar este procedimento? Esta ação não
              poderá ser desfeita.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Voltar
            </Button>
            <Button onClick={confirmarCancelamento} color="error" autoFocus>
              Confirmar Cancelamento
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={modalBulkOpen}
          onClose={() => setModalBulkOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Executar {procedimentosSelecionados.length} Procedimentos
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: "20px" }}>
              Será aplicada a mesma evolução para todos os procedimentos
              selecionados:
            </DialogContentText>

            <ul style={{ marginBottom: "20px", color: "#666" }}>
              {procedimentosSelecionados.map((item, idx) => (
                <li key={idx}>{item.procedimento.tratamento.designacao}</li>
              ))}
            </ul>

            <textarea
              placeholder="Escreva aqui a evolução dos procedimentos..."
              value={evolucaoBulk}
              onChange={(e) => setEvolucaoBulk(e.target.value)}
              rows={4}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "4px",
                border: "1px solid #ddd",
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setModalBulkOpen(false)} color="primary">
              Voltar
            </Button>
            <Button
              onClick={handleGuardarBulk}
              color="primary"
              disabled={isSubmiting}
              variant="outlined"
            >
              {isSubmiting ? "Guardando..." : "Guardar Todos"}
            </Button>
            <Button
              onClick={handleFinalizarBulk}
              color="primary"
              disabled={isSubmiting}
              variant="contained"
              autoFocus
            >
              {isSubmiting ? "Finalizando..." : "Finalizar Todos"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default ExecutarPlanoTratamento;
